import { NgModule, Component, Input, Output, EventEmitter, ChangeDetectionStrategy, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { transition, state, style, animate,  trigger } from '@angular/animations';
import { VgStates, VgEvents, VgAPI } from 'videogular2/core';
import { Subject } from 'rxjs/Subject';

@Component({
    selector: 'micro-video-player',
    templateUrl: 'micro-video-player.template.html',
    styleUrls: ['./micro-video-player.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger('fade', [
          state('in', style({opacity: 1})),
          state('out', style({opacity: 0})),
          
          transition(':enter', [
            style({opacity: 0}),
            animate(500)
          ]),
          transition('in => out', [
            animate(500)
          ])
        ])
      ]
})
export class MicroVideoPlayer {
    @Input() 
    get src():any {
        
        if(this._videoSource)
        {
            let source = this.getVideoUrl(this._videoSource, "fallback");

            if(!source)
            source = this.getVideoUrl(this._videoSource, "main");

            return source;
        }
            
        
        return {url:null};
    }
    set src(val:any){
        this._videoSource = val;
    }
    @Input() show:string = "in";
    @Output() currentTimeChange:EventEmitter<number> = new EventEmitter<number>();
    @Output() animationComplete:EventEmitter<boolean> = new EventEmitter<boolean>();

    @ViewChild('media') video: any;

    @Input()
    get currentTime() {
        return this._currentTime;
    }
    set currentTime(val:number){
        this._currentTime = val;
        this.currentTimeChange.emit(this._currentTime);
    }


    @Input() durationWatched;
    public getVideoUrl(array:Object[], key:string):any
    {
        return array.find((obj) => { return obj["type"] === key});
    }

    private media:any;
    private isPlaying:boolean = false;
    private _hideImage:boolean = false;
    private _currentTime:number = 0;
    private _videoSource:Array<Object> = [];
    private ngUnsubscribe: Subject<void> = new Subject<void>();

    public set hideImage(val:boolean){
        if(!val)
            this.isPlaying = false;

        this._hideImage = val;
    }

    public get hideImage():boolean{
        return this._hideImage;
    }

    ngOnDestroy(){
        if (this.ngUnsubscribe) {
            this.ngUnsubscribe.next();
            this.ngUnsubscribe.complete();
            this.ngUnsubscribe.unsubscribe();
            this.ngUnsubscribe = null;
        }
    }

    animationDone($event) {
        if($event.toState == "out"){
            this.animationComplete.emit(true);
        }
    }

    public onPlayerReady(api: VgAPI) {
        this.media = api.getDefaultMedia();
        this.media.volume = 0;
        this.media.elem.muted = true;
        
        this.media.subscriptions.canPlay.takeUntil(this.ngUnsubscribe).subscribe(() => {
            if(!this.isPlaying)
            {   
                this.media.seekTime(this.durationWatched? this.durationWatched  :this.currentTime);
                this.media.play();
            }
            this.isPlaying = true;
        });

        this.media.subscriptions.timeUpdate.takeUntil(this.ngUnsubscribe).subscribe(() => {
            if(this.media.currentTime > this.currentTime)
                this.currentTime = this.media.currentTime;
        });

        this.media.subscriptions.ended.takeUntil(this.ngUnsubscribe).subscribe(() => {
            this.currentTime = this.durationWatched? this.durationWatched : 0;
            this.media.seekTime(0);
            this.media.play();
        });
    }
}



// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/video-player/micro-video-player.component.ts